<template>
  <div class="ytf" :class="{cued: cued}">
    <div class="vid-filler"></div>
    <div class="player-hider" :class="{cued: cued}">
      <div class="player"  ref="player"></div>
    </div>
    <div class="video-loader-icon" :class="{cued: cued}"></div>
  </div>
</template>

<script>
import YTPlayer from 'yt-player'
import vu from '@/utils/video-parser.js'


export default {
  props: {
    url: String,
    muted: Boolean,
    autoplay: Boolean
  },
  
  data () {
    return {
      cued: false
    }
  },
  
  mounted () {
    this.init()
  },
  methods: {
    init: async function ()  {
      console.log('doing init')
      if(this.url) {
        let code = vu.getYoutubeCode(this.url)
        
        this.player = new YTPlayer(this.$refs.player, {
          autoplay: this.autoplay,
          modestBranding: true,
          related: false
        })
        this.player.load(code, this.autoplay)
        if(this.mute) this.player.mute()
        this.player.on('cued', () => {
          this.setSize()
        })
        this.player.on('playing', () => {
          this.setSize()
        })
      }
      else {
        if(this.player){
          this.player.destroy()
        }
      }
      
    },
    setSize () {
      let w = this.$el.offsetWidth
      if(w > 0){
        let h = Math.round(w  * 0.5625) + 'px'
        this.player.setSize(w, h)
        this.cued = true
      }
    }
  },
  beforeDestroy () {
    if(this.player) {
      this.player.destroy()
    }
  },
  watch: {
    url () {
      this.player.destroy()
      this.cued = false
      this.init ()
    },
    autoplay () {
      this.init ()
    }
  }
}
</script>

<style scoped>
.ytf{
  width:100%;
  height:100%;
  position:relative;
  background-color:#666;
}

.ytf.cued{
  background-color:#fff;
}

.player-hider{
  opacity:0;
  transition:opacity 0.2s ease;
  position:relative;
  height:0;
}

.player-hider.cued{
  opacity:1;
  height:auto;
}

.vid-filler{
  width:100%;
  height:0;
  padding-bottom:56.25%;
}

.cued .vid-filler
{
  display:none;
}
 

</style>